'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('style-inject');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styleInject__default = /*#__PURE__*/_interopDefaultLegacy(styleInject);

var css_248z = ".Divider-module_hr__Ej0Np{border:none;border-bottom:1px solid #e0e0e0}";
var styles = {"hr":"Divider-module_hr__Ej0Np"};
styleInject__default["default"](css_248z);

exports["default"] = styles;
